import React, { Component, Fragment } from 'react'
import { Flex } from 'reflexbox'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import Dropdown from 'containers/Project/Options/Dropdown.jsx'
import HulkRequest from 'containers/Project/HulkRequest/index.jsx'

import Tag from 'components/display/Tag'
import { TAG_COLORS } from 'components/display/Tag/constants'
import Collapse from 'components/fulcrum/collapse/Collapse'
import { IconButton } from 'react-toolbox/lib/button'
import { 
  collapseSelector,
  collapsingSelector,
  moreInfoCollapseSelector,
  relatedProjectsCollapseSelector,
  relatedProjectsShowAllSelector,
  stickySelector
} from './selectors'
import {
  hierarchyTypeSourceSelector,
  projectsSourceSelector
} from 'containers/Project/Hierarchies/selectors'
import { scrolledTop } from 'containers/Project/View/selectors'
import {
  collapseHeader,
  expandHeader,
  toggleHeader,
  toggleMoreInfo,
  toggleRelatedProjects,
  toggleRelatedProjectsShowAll,
  setCollapsing,
  setSticky
} from './actions'

import {
  fetchHierarchies,
  openDialog as openHierarchiesDialog
} from 'containers/Project/Hierarchies/actions'
import {
  fetchDescription,
} from 'containers/Project/Description/actions'
import { connect } from 'react-redux'
import cn from 'classnames'
import Tooltip from 'react-toolbox/lib/tooltip';
import GpuSku from 'components/project/notebookGpuSku/index'
import MoreInfo from 'components/custom/MoreInfo'
import EditDialog from 'containers/Project/Hierarchies/EditDialog'
import T from 'i18n-react'
import { Link } from 'react-router-dom'
import { lifecycle, mapProps } from 'recompose'
import { compose } from 'recompose'
import { GLOBAL_ROLES, PROJECT_ROLES, PRODUCT_ROLES } from 'containers/Role/constants'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import notifyHoc from 'containers/App/Notification/Notify'
import ProjectDescription from 'containers/Project/Description'
import Thumbnail from 'containers/Project/Thumbnail'
import {
  projectDescriptionSourceSelector
} from 'containers/Project/Description/selectors'

const InfoButton = notifyHoc(IconButton)

const TooltipIcon = Tooltip(IconButton)

const showToTeam = compose(
  mapProps((props) => ({
    ...props,
    roles: [ 
      ...Object.values(PROJECT_ROLES),
      ...Object.values(PRODUCT_ROLES),
      GLOBAL_ROLES.ADMIN_ACCESS
    ]
  })),
  showOnAnyRoles
)

const mapStateToProps = (state) => {
  return {
    collapse: collapseSelector(state),
    moreInfoCollapse: moreInfoCollapseSelector(state),
    relatedProjectsCollapse: relatedProjectsCollapseSelector(state),
    relatedProjectsShowAll: relatedProjectsShowAllSelector(state),
    scrolledTop: scrolledTop(state),
    hierarchyTypeSource: hierarchyTypeSourceSelector(state),
    hierarchiesProjectsSource: projectsSourceSelector(state),
    collapsing: collapsingSelector(state),
    sticky: stickySelector(state),
    projectDescriptionSource: projectDescriptionSourceSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    collapseHeader: () => dispatch(collapseHeader()),
    expandHeader: () => dispatch(expandHeader()),
    toggleHeader: () => dispatch(toggleHeader()),
    toggleMoreInfo: () => dispatch(toggleMoreInfo()),
    toggleRelatedProjects : () => dispatch(toggleRelatedProjects()),
    toggleRelatedProjectsShowAll: () => dispatch(toggleRelatedProjectsShowAll()),
    openHierarchiesDialog: () => dispatch(openHierarchiesDialog()),
    fetchHierarchies: (projectId) => dispatch(fetchHierarchies(projectId)),
    fetchDescription: (projectId) => dispatch(fetchDescription(projectId)),
    setCollapsing: (collapsing) => dispatch(setCollapsing(collapsing)),
    setSticky: (sticky) => dispatch(setSticky(sticky))
  }
}

class Header extends Component {
  componentDidMount() {
    const { id, fetchHierarchies, fetchDescription } = this.props
    fetchHierarchies(id)
    fetchDescription(id)
  }

  toggleCollapse = () => {
    const {
      toggleHeader
    } = this.props

    toggleHeader()
  }

  getRestrictedIcon = (restricted) => {
    if(restricted){
      return(
        <TooltipIcon tooltip='Restricted Project' tooltipPosition='right' icon='lock' styleName='restrictedIcon' theme={styles}/>
      )
    }
    return
  }

  getLifecycleTag = (lifecycle) => {
    if(lifecycle){
      return(
        <Tag color={TAG_COLORS.GREEN} text={lifecycle} className={styles.lifecycleTag}/>
      )
    }
    return
  }

  getRiskTag = (isRisk) => {
    if(isRisk){
      return(
        <Tag color={TAG_COLORS.RED} text='Risk' icon='warning' className={styles.riskTag}/>
      )
    }
    return
  }

  getReadOnlyTag = (readOnly) => 
    (readOnly && <Tag color={TAG_COLORS.RED} text='Read-Only' className={styles.readOnlyTag}/>)
  

  getHierarchyTypeTag = () => {
    const { hierarchyTypeSource } = this.props
    const text = T.translate(`project.hierarchies.${hierarchyTypeSource}`)
    return(<Flex styleName='tagRow'><Tag color={hierarchyTypeSource == 'primary' ? TAG_COLORS.GREEN : TAG_COLORS.GREY} text={text} className={styles.hierarchiesTag}/></Flex>)
  }

  renderProjectHierarchies = () => {
    const { 
      hierarchiesProjectsSource,
      relatedProjectsShowAll,
      toggleRelatedProjectsShowAll
    } = this.props
    if (hierarchiesProjectsSource.length === 0) {
      return (<div className={styles.noRelatedHierarchies}>There are no associated projects</div>)
    }
    let projects = hierarchiesProjectsSource
    if (projects[0].length !== 0) {
      projects = projects.map((project) => {
        return project[0]
      })
    } else {
      projects = []
    }
    const expandable = projects.length > 2 
    const showPartial = expandable && !relatedProjectsShowAll
    const projectsToShow = showPartial ? projects.slice(0,2) : projects
    const projectsToRender = 
      (<table className={styles.hierarchiesTable}>
        <tbody>
        {projectsToShow.map(p => {
          const AeRes = showToTeam(() => <td>{`AE Resource Level: ${p.aeResourceLevel}`}</td>)
          return (<tr key={p.id}>
          <td><Link to={`/project/${p.id}/view`} target="_blank">{p.id}</Link></td>
          <td>{p.name ? p.name : ''}</td>
          <td>{p.sku}</td>
          <AeRes />
          <td className={styles.comments}>{p.comments && p.comments !== "" && `(${p.comments})`}</td>
          </tr>)})}
          </tbody>
        </table>)
    return(<Fragment>
      {projectsToRender}
      {expandable && 
        <a className={styles.showMore} href="#" onClick={toggleRelatedProjectsShowAll}>{relatedProjectsShowAll ? `show less`: `show all (${hierarchiesProjectsSource.length - 2} more)`}</a>}
      </Fragment>
    )
  }

  collapsingStart = () => {
    const { scrolledTop, setSticky } = this.props
    if (scrolledTop) setSticky(false)
  }

  collapsingEnd = () => {
    const { scrolledTop, setSticky } = this.props
    if (!scrolledTop) setSticky(true)
  }

  render() {

    const {
      collapse,
      sticky,
      id,
      name,
      sku,
      brand,
      gpuSku,
      partnerSiteName,
      lifecycle,
      segment,
      readOnly,
      createdBy,
      createdAt,
      productLine,
      productClass,
      customerClass,
      architecture,
      risk : projectTypeRisk,
      projectDescriptionSource,
      restricted,
      toggleMoreInfo,
      moreInfoCollapse,
      toggleRelatedProjects,
      relatedProjectsCollapse,
      openHierarchiesDialog,
      hierarchyTypeSource,
    } = this.props

    const isRisk = projectTypeRisk || (projectDescriptionSource && projectDescriptionSource.risk)

    const icon = collapse ? 'chevron_right' : 'expand_more'

    const containerClasses = cn(styles.headerContainer, sticky ? styles.headerContainerScroll : null)

    const EditHierarchies = showToTeam(() => (<div className={styles.sideIconWrapper}>
        {'['}<InfoButton className={styles.sideIcon} icon={"edit"} theme={styles} onClick={openHierarchiesDialog} message={T.translate('pages.project.view.notification.viewHierarchiesInfo')}/>{"]"}
      </div>))

    return (
        <Flex className={containerClasses}>
          <Flex className={styles.subHeader}>
          <IconButton styleName='moreInfoIcon' icon={icon} theme={styles} onClick={this.toggleCollapse}/>
            <h4 className={styles.title}>Project #{id} {` | ${name}`}</h4>
            { this.getLifecycleTag(lifecycle) }
            { this.getRestrictedIcon(restricted) }
            { this.getRiskTag(isRisk) }
            { this.getReadOnlyTag(readOnly)}
          <Dropdown/>
          <HulkRequest/>
          </Flex>
          <Collapse collapse={collapse} theme={cn(styles.collapse, styles.outerCollapse)} onAnimationStart={this.collapsingStart} onAnimationEnd={this.collapsingEnd} duration={0}>
            <div>
              <Flex>
                <div className={styles.mainInfo}>
                  <div>{partnerSiteName}</div>
                  <div>{segment}{` - ${productLine}`}</div>
                  <div>{sku} - {brand}</div>
                  {hierarchyTypeSource && this.getHierarchyTypeTag()}
                </div>
                <ProjectDescription />
              </Flex>
              <Flex className={styles.hierarchiesHeader}>
                <MoreInfo className={styles.moreInfoButton} action={()=>toggleRelatedProjects()} collapsed={relatedProjectsCollapse} text={T.translate('project.header.hierarchies')}/>
                <EditHierarchies />
              </Flex>
              <Collapse collapse={relatedProjectsCollapse} theme={styles.moreInfoCollapse}>
                {this.renderProjectHierarchies()}
              </Collapse>
              <MoreInfo className={styles.moreInfoButton} action={()=>toggleMoreInfo()} collapsed={moreInfoCollapse} />
              <Collapse collapse={moreInfoCollapse} theme={styles.moreInfoCollapse}>
                <div>{productClass} - {customerClass}</div>
                <div>{architecture} </div>
                <div>
                  <GpuSku
                    segment={segment}
                    gpuSku={gpuSku}
                  />
                </div>
                <div styleName='projectCreationInfo'>Created by {createdBy} on {createdAt}</div>
                <div></div>
              </Collapse>
            </div>
            <Thumbnail />
          </Collapse>
          <EditDialog />
        </Flex>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withStyles = CSSModules(styles)
const enhance = compose(
  withConnect,
  withStyles,
)

export default enhance(Header)
